import React from 'react';

const LuminisDatePickerContainer = props => {
  return (
    <div className="luminis-date-picker-container">
      <div className={props.className}>
        {!props.showInline &&
          <>
            <div className="close-section">
              <button className="close-button styleless-button"
                      onClick={props.closeDatePicker} type='button'>
                <svg
                  className="close-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  fill="#000"
                >
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path
                    d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"/>
                </svg>
                {props.closeCalendarText}
              </button>
            </div>
            <div className="divider" />
          </>
        }
        <div className="calendar-section" style={{ position: 'relative' }}>
          {props.children}
        </div>
        <div className="divider divider-skinny" />
        <div className="daily-slots-section">
          <div className="times-section">
            {`${props.currentDateText} ${props.timesText}`}
          </div>
          <div className="slots-section">
            {props.selectedTimeSlots &&
              props.selectedTimeSlots.map(slots => {
                return ( slots.slot !== "" && (
                  <>
                    <button
                      className={`styleless-button slot ${slots.slot === props.slotSelected ? "slot--selected " : ""}` + (slots.hasTelemedicine && props.isTelehealthSelected && " telemedicine-slot")}
                      onClick={props.slotOnChange}
                      type="button"
                      data-slotvalue={slots.slot}
                      data-durationmins={slots.durationMins}
                      data-visittypes={JSON.stringify(slots.visitTypes)}
                      data-accessibility={slots.accessibility}
                      data-insurancerequirement={slots.insuranceRequirement}
                      data-referralrequirement={slots.referralRequirement}
                      data-appointmentnotesrequired={slots.appointmentNotesRequired}
                      data-deptid={slots.deptId}
                    >
                      { slots.hasTelemedicine && props.isTelehealthSelected &&
                        <img className='telehealth__icon' src='/themes/custom/luminis/images/icon_videocam.svg' />
                      }
                      {props.getHoursFromDate(slots.slot)}
                    </button>
                  </>
                ));
              })}
          </div>
        </div>
        <div className="divider" />
        {!props.showInline &&
          <div className="done-section">
            <button className='base-button outline day__time-block slot-set' type="button"
                    onClick={props.saveDatePickerAndReserveTimeSlot}>{props.doneText}</button>
          </div>
        }
        {props.showInline &&
          <>
            {props.slotSelected &&
              <div className="selected-time-section">
                <div
                  className="selected-time-label">{props.selectedDayAndTimeText}</div>
                <div
                  className="selected-time">{props.currentDateText} {props.selectedDayAndTimeTextJoiner} {props.getHoursFromDate(props.slotSelected)}</div>
              </div>
            }
            <div className="continue-section">
              <button className='base-button seafoam continue-button' type="button"
                      onClick={props.continueOnSubmit}>{props.continueText}</button>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default LuminisDatePickerContainer;
